/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

Liferay.Workflow = {
	ACTION_PUBLISH: 1,

	ACTION_SAVE_DRAFT: 2,

	STATUS_ANY: -1,

	STATUS_APPROVED: 0,

	STATUS_DENIED: 4,

	STATUS_DRAFT: 2,

	STATUS_EXPIRED: 3,

	STATUS_PENDING: 1,
};
